import { createContext, useContext } from 'react';

/* Light/dark mode for the Instructor panel. Provided at the panel
   root (MyRoutes) and consumed by the content page's toggle. */
export const ThemeModeContext = createContext({
  mode: 'light',
  toggleMode: () => {},
  toggleModeFromEvent: () => {},
  setThemeWithBubble: () => {},
});

export const useThemeMode = () => useContext(ThemeModeContext);
